import React from "react";

function Cmd({ bar }) {
  return (
    <div
      className={`${
        bar ? "md:block  col-span-10 mr-16" : "md:block  col-span-11 mr-10"
      }`}
    >
      <div className="text-4xl  text-orange-700 mb-5 w-1/6 rounded-l-xl bg-slate-700 text-center relative left-8 p-1 mt-10">
        تولید نرم افزار
      </div>
      <div
      style={{direction:"rtl"}}
        class="w-1/2 bg-orange-100 border-l-4 border-orange-500 text-orange-700 p-4 m-auto"
        role="alert"
      >
        <p class="font-bold text-3xl">توجه !!!</p>
        <p className="font-bold text-center text-5xl">این قسمت در دست ساخت است</p>
      </div>
    </div>
  );
}

export default Cmd;
